import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../auth/authContext';
import { callEdgeFunction } from './edgeFunction';

export type AdminSessionResult =
  | { isAdmin: false; aal: 'aal1' | 'aal2' | null; mfaEnrolled: boolean }
  | { isAdmin: true; userId: string; aal: 'aal1' | 'aal2' | null; mfaEnrolled: boolean };

/** The admin portal's only way to learn admin-ness (plan L187) — reads
 * `profiles.is_admin` server-side via the `admin-session` edge function,
 * since that column has no client SELECT grant. `{ isAdmin: false }` is a
 * normal, cacheable answer for a signed-in non-admin, not an error. */
export function useAdminSession() {
  const { supabase, session } = useAuth();
  const userId = session?.user.id ?? null;
  return useQuery({
    queryKey: ['admin-session', userId],
    queryFn: () => callEdgeFunction<AdminSessionResult>(supabase, 'admin-session'),
    enabled: !!session,
    staleTime: 15_000,
  });
}
